import { AdvancedExchangeRecommendationOutputSchema } from "@redotech/redo-agents-common/returns-agents/exchange-agent/advanced-exchange-recommendation";
import { ReturnReasonSchema } from "@redotech/redo-agents-common/returns-agents/exchange-agent/return-reasons";
import { ReturnProductSchema } from "@redotech/redo-return-core-common/draft-return/draft-return-items";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export type { AdvancedExchangeRecommendationOutput } from "@redotech/redo-agents-common/returns-agents/exchange-agent/advanced-exchange-recommendation";

export const getAdvancedExchangeRecommendation = unaryRpc({
  name: "getAdvancedExchangeRecommendation" as const,
  input: z.object({
    draftReturnId: z.string(),
    returnProduct: ReturnProductSchema,
    otherProductsBeingReturned: z.array(ReturnProductSchema).optional(),
    returnReasons: z.array(ReturnReasonSchema),
    locale: z.string().optional(),
  }),
  output: AdvancedExchangeRecommendationOutputSchema,
});
